import React from 'react';
import ProductCanvas from './product-implant';

const ProductItem = ({ uniq, product, showImg }) => {
  return (
    <tr id={uniq + '-' + product.Model}>
      <td>{product['Volume']}</td>
      <td>{product['Width cm']}</td>
      <td>{product['Height cm']}</td>
      <td>{product['Projection cm']}</td>
      <td
        className="no-wrap"
        style={{ backgroundColor: 'rgb(231, 245, 253)', fontWeight: 'bolder' }}
      >
        {product['Product Code']}
      </td>
      <td>{product['Sizer']}</td>
      <td>{product['Tabs']}</td>
      <td>{product['Projection']}</td>
      <td className="no-wrap">{product.Model}</td>
      <td>{product['Surface']}</td>
      <td>{product['Lower Pole Arc A-B']}</td>
      {showImg ? (
        <td>
          <ProductCanvas {...product} />
        </td>
      ) : null}
    </tr>
  );
};

export default ProductItem;
